<template>
  <div class="form-group" :class="{ 'has-error': errors.has(fieldId) }">
    <label class="checkbox-middle">
      <input type="checkbox"
             :class="cssClass"
             :name="fieldId"
             :checked="value"
             @change="updateValue($event.target.checked)"
             v-validate="validation"
             data-vv-value-path="value"
             data-vv-validate-on="input" />
             {{ label }}
      <p class="text-danger" v-if="errors.has(fieldId)">{{ errors.first(fieldId) }}</p>
    </label>
  </div>
</template>
<script>
  export default {
    inject: ['$validator'],
    props: {
      value: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: true
      },
      cssClass: {
        type: String,
        required: false
      },
      fieldId: {
        type: String,
        required: true
      },
      validation: {
        type: String,
        default: ''
      }
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/form/checkboxField.vue